import axios from 'axios'
import store from '@/store'


const protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http'

const appAxios = function (token = null) {
  return axios.create({
    baseURL: `${protocol}://${process.env.VUE_APP_SERVER_DNS}/api/`,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${token}`,
    },
  })
}

export const authAxios = () => {
  const token = store.state?.auth?.token
  if (!token) throw new Error('session token not found')
  return appAxios(token)
}

export default appAxios
